import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useEffect } from 'react';

const useSelectorWithDispatch = (selector, action, condition) => {
    const data = useSelector(selector, shallowEqual);
    const dispatch = useDispatch();
    useEffect(() => {
        if (condition(data)) {
            dispatch(action());
        }
    }, [condition(data)]);
    return data;
};
export default useSelectorWithDispatch;
